module.exports = __webpack_public_path__ + "img/P150T_weapon_32.4defa7e5.png";